import { createMutation } from "@/mutations";
import { exchangeCodeForTokens } from "@/features/auth/api/session";
import type { AxiosResponse } from "axios";
import type { TokensResponse } from "@/features/auth/api/session";

type ExchangeCodeResponse = Awaited<
  ReturnType<typeof exchangeCodeForTokens>
> extends AxiosResponse<infer T>
  ? T
  : never;

export const useExchangeCodeForTokensMutation = () => {
  return createMutation<ExchangeCodeResponse, string>({
    mutationFn: async (code) => {
      const response = await exchangeCodeForTokens(code);
      return response.data;
    },
    invalidateQueries: (key) => Array.isArray(key) && key[0] === "userInfo",
  });
};

